module.exports = __webpack_public_path__ + "static/media/2.a609d5e7.svg";